var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uik-menuDrop"},[_c('transition',{attrs:{"name":"uik-dropdown"}},[(_vm.state)?_c('div',{class:['uik-menuDrop__list', _vm.position !== '' ? 'uik-menuDrop__' + _vm.position:false]},[_vm._t("default")],2):_vm._e()]),_c('UikOverlay',{attrs:{"visible":_vm.state,"opacity":5},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }